export enum EnvironmentNameEnum {
  Production = 'production',
  Development = 'development',
  ChromeDev = 'chrome-dev',
}
